import { FC, useEffect } from 'react';

import { getAccessToken } from 'utils/account';
import Location from 'modules/Location';

export const LoginButton: FC = () => {
  const isInLoginButtonPopupOrIframe = () =>
    Location.isInLoginButtonPopup() || Location.isInLoginButtonIframe();

  useEffect(() => {
    if (!isInLoginButtonPopupOrIframe()) {
      return;
    }

    if (Location.getUrlParam('code')) {
      Location.sendPostMessage({
        data: {
          code: Location.getUrlParam('code'),
          state: Location.getUrlParam('state'),
        },
      });
    } else {
      Location.sendPostMessage({
        data: {
          access_token: getAccessToken(),
          scopes: Location.getHashParam('scope'),
          expires_in: Location.getHashParam('expires_in'),
          state: Location.getHashParam('state'),
          token_type: Location.getHashParam('token_type'),
        },
      });
    }
  });

  if (!isInLoginButtonPopupOrIframe()) {
    return <div>You cannot open this page directly.</div>;
  }

  return null;
};
